import { render, staticRenderFns } from "./CheckoutSummaryDefault.vue?vue&type=template&id=10f52c88"
import script from "./CheckoutSummaryDefault.vue?vue&type=script&lang=js"
export * from "./CheckoutSummaryDefault.vue?vue&type=script&lang=js"
import style0 from "./CheckoutSummaryDefault.vue?vue&type=style&index=0&id=10f52c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports